<mat-dialog-content>
  <lemon-dialog-header> Reskontratapahtuman raakadata </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em" [innerHTML]="data | ljson"></div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button mat-dialog-close actionId="Peruuta (reskontratapahtuman raakadata dialog)">{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
</mat-dialog-actions>
